import React, { useEffect, useState } from "react";
import errorIcon from "../Assets/Icons/error_message.png";
import calendarIcon from "../Assets/Icons/today.png";
import "../App.css";

const DateMonthCal = ({ onChange, title = 'Date of Invoicing', value, errorMessage }) => {
    const [selectedDate, setSelectedDate] = useState(value);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [showCalendar, setShowCalendar] = useState(false);

    useEffect(() => {
        if (value) {
            const [day, month] = formatDate(value).split("/");
            setSelectedDay(parseInt(day, 10));
            setSelectedMonth(parseInt(month, 10) - 1);
            setSelectedDate(value);
        }
    }, [value]);

    // Month names
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Function to determine the number of days in a given month
    const getDaysInMonth = (month) => {
        const year = new Date().getFullYear(); // Use current year
        return new Date(year, month + 1, 0).getDate(); // Get last day of the month
    };

    const handleDateSelection = (day) => {
        const formattedDate = `${day < 10 ? "0" + day : day}/${selectedMonth + 1 < 10 ? "0" + (selectedMonth + 1) : selectedMonth + 1}`;
        setSelectedDate(formattedDate);
        setSelectedDay(day);
        setShowCalendar(false);
        if (onChange) onChange(formattedDate);
    };

    const formatDate = (dateString) => {
        const ddMMRegex = /^\d{2}\/\d{2}$/;
        if (ddMMRegex.test(dateString)) {
            return dateString;
        }
        try {
            const gmtDate = new Date(dateString + " UTC");
            if (isNaN(gmtDate.getTime())) {
                throw new Error("Invalid date format");
            }
            return gmtDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
            });
        } catch (error) {
            console.error("Error parsing date:", error.message);
            return "";
        }
    };

    return (
        <div style={{ position: "relative", display: "flex", flexDirection: "column" }}>
            <label style={{
                marginBottom: "5px", fontWeight: '400', fontSize: '12px',
                fontFamily: 'Roboto',
                color: 'rgb(52, 60, 68)'
            }}>
                {title}
            </label>

            <input
                type="text"
                value={formatDate(selectedDate)}
                placeholder="DD/MM"
                readOnly
                onClick={() => setShowCalendar(!showCalendar)}
                className="dateMonthBox"
                style={{ border: errorMessage ? "1px solid red" : "1px solid #d6e4ec" }}
            />
            <img
                src={calendarIcon}
                alt="Calendar"
                style={{ width: "16px", height: "16px", cursor: "pointer", position: 'absolute', top: 35, right: 10 }}
                onClick={() => setShowCalendar(!showCalendar)}
            />

            {showCalendar && (
                <div style={{
                    position: "absolute",
                    top: "50px",
                    left: "5px",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    padding: "10px",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                    zIndex: 1000,
                    borderRadius: "4px",
                }}>
                    {/* Month Selection */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                        <button
                            onClick={() => setSelectedMonth((prev) => (prev > 0 ? prev - 1 : 11))}
                            style={{ cursor: "pointer", background: "none", border: "none", fontSize: "12px" }}
                        >
                            ◀
                        </button>
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>{months[selectedMonth]}</span>
                        <button
                            onClick={() => setSelectedMonth((prev) => (prev < 11 ? prev + 1 : 0))}
                            style={{ cursor: "pointer", background: "none", border: "none", fontSize: "12px" }}
                        >
                            ▶
                        </button>
                    </div>

                    {/* Days Grid (Dynamically Adjusted) */}
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "5px" }}>
                        {Array.from({ length: getDaysInMonth(selectedMonth) }, (_, i) => i + 1).map((day) => (
                            <button
                                key={day}
                                onClick={() => handleDateSelection(day)}
                                className="hover-button"
                                style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "4px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    backgroundColor:
                                        selectedDay === day && selectedMonth === parseInt(selectedDate?.split("/")[1], 10) - 1
                                            ? "blue" // Highlight ONLY if selected day and displayed month match
                                            : "#f8f8f8",
                                    color: selectedDay === day && selectedMonth === parseInt(selectedDate?.split("/")[1], 10) - 1
                                        ? "white"
                                        : "black",
                                }}
                            >
                                {day}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {/* Error Message */}
            {errorMessage && (
                <div style={styles.errorMessage}>
                    <span>
                        <img src={errorIcon} alt="Error" style={{ width: "12px", height: "12px" }} />
                    </span>{" "}
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

const styles = {
    errorMessage: {
        color: "#EE201C",
        fontSize: "11px",
        marginTop: "4px",
        display: "flex",
        gap: "4px",
        fontWeight: "400",
    },
};

export default DateMonthCal;
